<div class="toast-container toast-top-right" aria-live="polite" aria-atomic="true">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="ngx-toastr toast-{{ toast.type }}" role="alert" aria-live="assertive" aria-atomic="true" (click)="toastService.remove(toast.id)">
      <div class="toast-title">{{ toast.title }}</div>
      <div class="toast-message">{{ toast.message }}</div>
    </div>
  }
</div>
